import ConditionalRender from '../../helpers/ConditionalRender';
import { prettifyChangesDetailsString, stringFormatting } from "../../helpers/utils";
import React from "react";

function severityText (severity: number): string
{
	switch (severity)
	{
		case 1: return 'critical';
		case 2: return 'warning';
		case 3: return 'info';
		default: return 'normal';
	}
}

function comparator (event: any): string
{
	if (event.changeType === 'status')
	{
		switch (event.severity)
		{
			case 1: return '>';
			case 2: return '<';
			default: return '=';
		}
	}
	else
	{
		if (event.decreasing === 'true')
		{
			return event.severity > 0 ? '<' : '>';
		}
		else
		{
			return event.severity > 0 ? '>' : '<';
		}
	}
}

export default function InstanceEvents(props: { event: any }) {
    const { event } = props;
    const formattedText = event.details ? event.details.replace(/\n/g, '<br />') : '' // Convert '\n' to '<br />' for HTML line breaks

    return (<React.Fragment>
        <ConditionalRender if={event.detailsUrl !== null && event.detailsUrl !== ''}>
            <a href={event.detailsUrl} target="_blank"
               rel="noopener noreferrer"
               dangerouslySetInnerHTML={{ __html: ((event.title === '') ? formattedText : `${event.title} - ${formattedText}`) }}/><sup
            className="fal fa-external-link fa-fw"/>
        </ConditionalRender>

        <ConditionalRender if={event.detailsUrl === null || event.detailsUrl === ''}>
            <ConditionalRender if={event.event === 'alert'}>
                <ConditionalRender if={event.changeType === 'status' || event.statistic === 'sensorstatus'}>
                    {/* Status alerts describe a state, not a comparison — match the chart tooltip format. */}
                    <span>{stringFormatting(event.name)}</span>
                    <strong> {severityText(event.severity)}</strong>
                </ConditionalRender>
                <ConditionalRender if={event.changeType !== 'status' && event.statistic !== 'sensorstatus'}>
                    <span>{stringFormatting(event.name)}</span>
                    <strong> {severityText(event.severity)}</strong>
                    <span> ({`${event.changeTo ? event.changeTo : ''}${event.units ? event.units : ''}`} </span>
                    <span> {comparator(event)}</span>
                    <span> {`${event.threshold ? event.threshold : ''}${event.units ? event.units : ''}`}) </span>
                </ConditionalRender>
            </ConditionalRender>

            <ConditionalRender if={event.event !== 'alert'}>
                <div
                    dangerouslySetInnerHTML={{ __html: ((event.title === '') ? `${formattedText} ` : `${event.title}${((formattedText) ? ` - ${formattedText} ` : ' ')}`) }}/>
            </ConditionalRender>
            <ConditionalRender if={event.changeFrom && event.changeTo}>
                (<strong>from </strong>
                <span data-tooltip-id="global-tooltip" data-tooltip-content={event.changeFrom?.length > 30 ? event.changeFrom : ''}>
                                {prettifyChangesDetailsString(event.changeFrom + (event.units ? event.units : ''))}
                            </span>
                <strong> to </strong>
                <span data-tooltip-id="global-tooltip" data-tooltip-content={event.changeTo?.length > 30 ? event.changeTo : ''}>
                                {prettifyChangesDetailsString(event.changeTo + (event.units ? event.units : ''))}
                            </span>)
            </ConditionalRender>
        </ConditionalRender>
    </React.Fragment>)
}
